class Engine {
  name = "Engine";
  components = [];
  
  constructor() {

  }

  add(component) {
    this.components.push(component);
  }

  clearLog() {
    this.components.forEach(component => component.log = []);
  }

  explain() {
    
  }

  get log() {
    return this.components.reduce((acc, component) => acc.concat(component.log), []).sort((a, b) => b.time - a.time);
  }

  /**
   * Static method to create a rule from a JS object or JSON string. Needs to be
   * here (rather than in the Rule class) to avoid circular dependencies.
   */
  static fromJSON(json) {
    throw new Error(`[U/E] Missing static fromJSON method implementation`);
  }
}

export default Engine;